import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingSpinner = ({ size = "sm", variant = "primary", className = "" }) => {
  return (
    <Spinner
      animation="border"
      size={size}
      variant={variant}
      className={className}
      role="status"
    >
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
};

export default LoadingSpinner;